import { t } from 'i18next';
import styled from 'styled-components';

import { StackedModalProps } from 'store/modalStackStore';

import Flex from 'components/util/Flex';

interface UnavailableWithdrawalModalProps extends StackedModalProps {}

const UnavailableWithdrawalModal = ({ closeModal }: UnavailableWithdrawalModalProps) => {
  return (
    <SUnavailableWithdrawalModal>
      <SUnavailableWithdrawalHeader align="center" justify="center">
        <p className="title">{t('chat.rewards_withdrawal_verify_complete')}</p>
      </SUnavailableWithdrawalHeader>
      <Flex justify="center">
        <SButton onClick={closeModal}>{t('chat.popup_done')}</SButton>
      </Flex>
    </SUnavailableWithdrawalModal>
  );
};

const SUnavailableWithdrawalModal = styled.div`
  width: 100%;
  padding: 40px 36px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

const SUnavailableWithdrawalHeader = styled(Flex)`
  .title {
    ${({ theme }) => theme.font.body1_m};
    text-align: center;
  }
`;

const SButton = styled.button`
  padding: 12px 0;
  width: 260px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.color.static.primary};
  color: ${({ theme }) => theme.color.static.white};
  ${({ theme }) => theme.font.body1_m};
`;

export default UnavailableWithdrawalModal;
